import styled from 'styled-components/native';

import { Text } from 'components/Text';

const Label = styled(Text)``;

export { Label };
